module.exports = __webpack_public_path__ + "f56650007eb0fc2472dd470c71193f45.svg";